import Blue from "~/core";

new Blue({
	name: 'Detail Layouts',
	selector: ".detail-layouts",
	setup(layouts) {
		let _this = this;
    let buttons = [...layouts.querySelectorAll('.detail-layout')];

		buttons.forEach(button => {
			_this.$addEvents(button, 'click', function(e) {
				const siblings = [...layouts.querySelectorAll('.detail-layout')].filter(item => item != button);
				siblings.forEach(sib => {
					sib.classList.remove('is-selected');
				});
				if(e.target.classList.contains('is-selected')) {
					e.target.classList.remove('is-selected');
				} else {
					e.target.classList.add('is-selected');
				}
			})
		})
	}
});

new Blue({
	name: 'Scroller',
	selector: ".detail-footerScroller",
	setup(scroller) {
		this.$addEvents(window, 'scroll', () => {
			if (window.pageYOffset > 10) {
				scroller.classList.add('hide');
			} else {
				scroller.classList.remove('hide');
			}
		})



	}
});
